import Typography from '@mui/material/Typography';


export default function InfoSeqText() {
  
  return (
<div>
    
    <Typography variant="h6" >
    
    Whole Genome Sequencing (WGS) was performed on the Oxford Nanopore Technologies (ONT) PromethION platform using long-read sequencing.
For this module, your genetic data was scanned against disease-specific panels curated by ClinGen, where thousands of researchers and clinicians have determined which genes should be evaluated for each condition.
<br /><br />
Variants were classified based on trusted databases such as ClinVar, ClinGen, and others, following established guidelines to ensure clinical relevance.
<br /><br />
Accuracy:<br /><br />
Sequencing technology is highly advanced and results are robust; however, no genetic test can predict disease with 100% certainty. <br /><br />
Genetic findings should always be discussed with a healthcare professional or genetic counselor to determine the appropriate next steps.


</Typography>    
</div>

   )
}